module.exports = __webpack_public_path__ + "media/images/swines/Swine in week 16 of pregnancy.jpg";